import { Injectable } from "@angular/core";
import {
	Router,
	CanActivate,
	ActivatedRouteSnapshot,
	RouterStateSnapshot,
	CanActivateChild,
} from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AuthenticationService } from "./authentication.service";
import { ToastrService } from "ngx-toastr";
import { debug } from "util";

/**
 * Decides if a route can be activated.
 */
@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {
	private signedIn: boolean;

	constructor(
		private toastr: ToastrService,
		private authenticationService: AuthenticationService,
		private router: Router
	) {}

	public canActivateChild(
		childRoute: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): boolean | Observable<boolean> | Promise<boolean> {
		return this.canActivate(childRoute, state);
	}

	public canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): boolean | Observable<boolean> | Promise<boolean> {
		return this.authenticationService.isSignedIn().pipe(
			map((signedIn: boolean) => {
				this.signedIn = signedIn;
				const url: string = state.url;
				this.authenticationService.redirectUrl = url;

				if (this.signedIn) {
					if (route.data.hasPermissions) {
						if (
							this.authenticationService.hasPermissions(
								route.data.hasPermissions
							)
						) {
							return true;
						} else {
							this.toastr.error(
								`Sorry, you don't have permission to open this page.`
							);
							this.router.navigate(["/"]);
							return false;
						}
					} else {
						return true;
					}
				}
				this.router.navigate(["/"]);
				return false;
			})
		);
		debugger;
	}
}
